<template>
  <div class="form-input">
    <div
      class="form-input__control"
      :style="inputStyle"
    >
      <div class="form-input__input">
        <input
          ref="input"
          v-bind="$attrs"
          :value="value"
          class="form-input__input"
          v-on="listeners"
          @input="$emit('input', $event.target.value)"
        >
      </div>
      <div
        v-if="$slots.icon"
        class="form-input__icon"
        @click="$refs.input.focus();"
      >
        <slot name="icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-input',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    inputStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  &__control {
    position: relative;
    background-color: #27274f;
    color: #b4b4d3;
    display: flex;
    border-radius: 3px;
    font-size: 14px;
    font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
    line-height: 30px;
    font-weight: 500;
  }
  &__input {
    flex: 1 1 auto;
    input {
      display: block;
      color: currentColor;
      width: 100%;
      padding: 0 10px 1px 10px;
      font-size: inherit;
      line-height: inherit;
      font-weight: inherit;
      font-family: inherit;
      appearance: none;
      background: transparent;
      border: none;
      margin: 0;
      height: 31px;
      outline: none;
    }
  }
  &__icon {
    flex: 0 0 31px;
    display: flex;
    cursor: default;
    align-items: center;
    justify-content: center;
    & > svg,
    & > img {
      max-width: 17px;
      max-height: 17px;
    }
  }
}
</style>
